import { SVGProps } from 'react';
import { ReactComponent } from 'icons/icon-sort-up.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const SortIconUp = (props: Props) => {
  return <ReactComponent className="merc-icon-sort-up" {...props} />;
};
